import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock, Loader2 } from "lucide-react";
import { AntennaLogo } from "@/components/site/AntennaLogo";
import { GlowOrbs } from "@/components/site/Primitives";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("ns_token", data.access_token);
      navigate("/admin");
    } catch (e) {
      const d = e.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Erro ao entrar. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 font-body text-white placeholder:text-slate-500 transition-colors focus:border-[#06B6D4] focus:outline-none focus:ring-2 focus:ring-[#06B6D4]/20";

  return (
    <div className="grain relative flex min-h-screen items-center justify-center bg-[#05050A] px-4 font-body text-white">
      <GlowOrbs />
      <div className="relative z-10 w-full max-w-md rounded-3xl border border-white/8 bg-[#0F0F1A] p-8 md:p-10">
        <div className="mb-8 flex items-center gap-2">
          <AntennaLogo className="h-6 w-6" />
          <span className="font-display text-xl font-black tracking-tighter">
            NOVA<span className="text-[#8B5CF6]">STREAM</span>
          </span>
        </div>
        <div className="mb-2 inline-flex rounded-2xl bg-[#8B5CF6]/15 p-3">
          <Lock className="h-6 w-6 text-[#a78bfa]" />
        </div>
        <h1 className="mt-4 font-display text-2xl font-black uppercase tracking-tighter">Painel de Leads</h1>
        <p className="mt-2 font-body text-sm text-slate-400">Acesse com sua conta de administrador.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <input data-testid="admin-email" type="email" className={inputCls} placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="admin-password" type="password" className={inputCls} placeholder="Senha" value={password} onChange={(e) => setPassword(e.target.value)} />
          {err && <p data-testid="admin-error" className="font-body text-sm text-red-400">{err}</p>}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[#8B5CF6] to-[#7c3aed] px-6 py-3.5 font-display font-bold text-white transition-transform hover:scale-[1.02] disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : null}
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
